module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco_logo-c4c5c673e8012563066caeaf1247d47c.png";